<template>
  <div class="header-top">
    <div class="title">
      <!-- {{ $route.meta.title }} -->
    </div>
    <div class="top_right">
      <div class="select-term">
        <template
          v-if="
            !!getUserInfo &&
            !!getUserInfo.companyList &&
            !!getUserInfo.companyList.length
          "
        >
          <el-select
            v-model="termValue"
            placeholder="请选择"
            size="small"
            @change="(e) => handleChangeTerm(e)"
          >
            <el-option
              v-for="item in getUserInfo.companyList"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </div>
      <div class="message">
        <el-badge is-dot class="item" :hidden="getShowhidden">
          <el-button
            @click="handleMessage"
            class="share-button"
            icon="el-icon-bell"
            type="primary"
          />
        </el-badge>
      </div>
      <button
        v-if="memberInfo.active === true"
        type="button"
        class="vip-tag"
      >
        <img :src="vipHeaderIcon" alt="VIP会员" />
      </button>
      <div class="user-info">
        <el-dropdown trigger="hover">
          <div class="user-info-wrap">
            <span class="user-header">
              <el-badge class="item">
                <img :src="url" alt="用户头像" />
              </el-badge>
            </span>
            <span class="el-dropdown-link">
              {{ getUserInfo.nickName || "佚名" }}
              <i class="el-icon-caret-bottom el-icon--right" />
            </span>
          </div>
          <el-dropdown-menu slot="dropdown" class="header-area">
            <el-dropdown-item
              class="user-center"
              @click.native="() => handleUserCenter()"
            >
              <span>{{ $t("personCenterV2.personCenter") }}</span>
            </el-dropdown-item>
            <el-dropdown-item
              class="purchase-record"
              @click.native="() => handleMemberHistory()"
            >
              <span>订单记录</span>
            </el-dropdown-item>
            <!-- <el-dropdown-item class="user-manage" @click.native="() => handleUserManage()" v-if="parseInt(getUserInfo.id) === parseInt(getRootUserInfo)">
              <span>{{$t('personCenterV2.userManage')}}</span>
            </el-dropdown-item> -->
            <el-dropdown-item
              class="login-out"
              @click.native="() => handleOut()"
            >
              <span>{{ $t("personCenterV2.logOut") }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="internationalize">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <span :class="`lang-${$i18n.locale}`">{{
              $i18n.locale === "zh" ? "中文" : "English"
            }}</span>
            <i class="el-icon-caret-bottom el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown" class="internationalize-drop">
            <el-dropdown-item @click.native="handleSwitchLang('zh')"
              >中文</el-dropdown-item
            >
            <el-dropdown-item @click.native="handleSwitchLang('en')"
              >English</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!--退出-->
    <logout :shown="shown" @handleCancel="handleCancel" />
  </div>
</template>

<script>
import { checkImgExists } from "@/utils/index";

import logout from "@/components/layer/logout";
import { mapActions } from "vuex";

export default {
  name: "Header",
  components: { logout },
  data() {
    return {
      radio: 1,
      value: "standard",
      activeLang: "中文",
      shown: false,
      url: require("./assets/images/user.png"),
      vipHeaderIcon: require("@/assets/imgs/payment/layout-header-icon.png"),
      termValue: "",
      // alignFlag: process.env.VUE_APP_HOSPITAL === "align",
    };
  },

  computed: {
    //获取用户信息
    getUserInfo() {
      return this.$store.getters["layout/getUserInfo"];
    },
    getRootUserInfo() {
      return this.$store.getters["layout/getRootUserInfo"] || [];
    },
    getShowhidden() {
      return this.$store.getters["layout/getShowhidden"];
    },
    memberInfo() {
      return this.$store.getters["layout/getMemberInfo"] || {};
    },
  },

  watch: {
    // 如果头像地址访问不到使用默认图片
    "getUserInfo.avatar": {
      handler(newVal) {
        checkImgExists(newVal)
          .then(() => {
            this.url = newVal;
          })
          .catch(() => {
            this.url = require("./assets/images/user.png");
          });
      },
      deep: true,
    },
  },

  mounted() {
    let termcompany = localStorage.getItem("companyCode");
    if (termcompany) {
      this.termValue = termcompany;
    }
    this.$store.dispatch("layout/showhidden");
    // 个人中心退出不是当前团队以及   homeMiddleware    页面调用
    this.bus.$on("changeTeam", (val) => {
      this.termValue = val;
    });
  },

  methods: {
    ...mapActions(["getTaskNums"]),
    // 上方图标跳转事件
    handleUserCenter() {
      if (this.$route.path === "/home/personCenter") {
        return;
      }
      this.$router.push({ name: "personCenter" });
    },

    handleMemberHistory() {
      this.$emit("open-member-history");
    },

    //用户管理
    handleUserManage() {
      if (this.$route.path === "/home/userManage") {
        return;
      }
      this.$router.push({ name: "userManage" });
    },

    swatchLang(lang) {
      switch (lang) {
        case "zh":
          this.activeLang = "中文";
          break;
        case "en":
          this.activeLang = "English";
          break;
      }
    },

    handleSwitchLang(lang) {
      if (lang === this.$i18n.locale) {
        return;
      }
      localStorage.setItem("i18n", lang);
      this.$i18n.locale = lang;
      this.swatchLang(lang);
      // 菜单更新国际化
      this.$store.dispatch("layout/reloadNavInfo");
      location.reload();
    },

    //退出登录
    handleOut() {
      this.shown = true;
    },
    //取消
    handleCancel() {
      this.shown = false;
    },

    //切换团队-公司
    handleChangeTerm(val) {
      const self = this;
      let params = Object();
      Reflect.set(params, "companyCode", val);
      self.$store.dispatch("layout/navInfo", val);
      self.$store.dispatch("layout/changeCompanyInfo", params).then((resp) => {
        if (resp.status === 200 && resp.success) {
          let result = resp.result;
          localStorage.setItem("myUser", JSON.stringify(result));
          localStorage.setItem("userInfo", JSON.stringify(result));
          localStorage.setItem("companyCode", val); // 公司编码
          localStorage.setItem("myCompanyCode", val); // 公司编码
          self.$nextTick(async () => {
            self.$router.push({ name: "homeMiddleware" });
            this.getTaskNums();
          });
          self.$store.dispatch("layout/navInfo", val);
        }
      });
    },

    handleMessage() {
      if (this.$route.path === "/home/myMessage") {
        return;
      }
      this.$router.push({ name: "myMessage" });
    },
  },
};
</script>
<style lang="less">
@import "./assets/global.less";
</style>
<style lang="less" scoped>
@import "./assets/style.less";
</style>

